import { useRouter } from "next/router";
import { Flex, FormControl, Input } from "@chakra-ui/react";
export function Search({ ph }) {
  const { replace, asPath } = useRouter();
  const searchHandeler = (event) => {
    event.preventDefault();
    let query = (query = event.target?.value);
    // setTimeout((query = event.target?.value), 1500);
    //here we used split to remove the query part from asPath we use the domain only 🚀 🤫
    // const curruntpath = path ? router.asPath.split("?")[0] : router.pathname;
    const curruntpath = asPath.split("?")[0];
    replace(`${curruntpath}?q=${query}`, undefined, { shallow: true });
  };
  return (
    <FormControl>
      <Flex as="form" my="4" mx={12}>
        <Input
          placeholder={`Search for ${ph}`}
          type="input"
          flex="1"
          px={2}
          borderRadius="md"
          borderWidth="1px"
          onChange={searchHandeler}
          // bg={useColorModeValue("blackAlpha.700","whiteAlpha.700")}
        />
      </Flex>
    </FormControl>
  );
}
